import { isPresent } from '@ember/utils';
import { modifier } from 'ember-modifier';

// selects all the text when an input textbox receives focus
// {{select-on-focus}}
export default modifier(function selectOnFocus(element) {
  let handler = generateOnFocusHandler();
  element.addEventListener('focus', handler);

  return () => {
    element.removeEventListener('focus', handler);
  };
});

function generateOnFocusHandler() {
  return (e) => {
    if (isPresent(e.target.value)) {
      e.target.select();
    }
  };
}
